import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/hackzurich2022-swissre-challenge/hackzurich2022-swissre-challenge/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`We collected some more videos and tutorials that might be interesting to you.`}</p>
    </PageDescription>
    <img {...{
      "src": "https://docs.microsoft.com/en-us/windows/mixed-reality/discover/images/designing-holograms/demo-room.gif?ocid=AID3054426",
      "alt": null
    }}></img>
    <h2>{`Mixed-Reality and Metaverse`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://youtu.be/_xpI0JosYUk"
        }}>{`Mixed Reality Blends the Physical and Virtual Worlds`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://youtu.be/rnJHHamrflw"
        }}>{`Metaverse (Satya Nadella 2022 Build Keynote)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=Qw6UCwCt4bE"
        }}>{`What is Microsoft’s Metaverse`}</a></li>
    </ul>
    <h2>{`Microsoft Hololens 2 - Case Studies and Inspiration`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://youtu.be/Chk489dEgVc"
        }}>{`Building the future: How NASA and Lockheed Martin are using HoloLens 2 to go to the moon and beyond`}</a></li>
    </ul>
    <h2>{`Developing for Mixed Reality`}</h2>
    <p>{`We created a minimum `}<a parentName="p" {...{
        "href": "https://github.com/EricVoll/MRTK_HelloWorld"
      }}>{`HelloWorld Unity project`}</a>{` including MRTK 3 (preview version) for you to clone and use as a starting point for your project. The sample scene contains a MRTK 3 Rig (which offers all sorts of hand-tracking/interaction for different platforms (HL2, SmartPhones etc.) and an example cube, which rests on a plane. If you click the “play” button in Unity, you can hold down the Space bar to simulate HL2’s hand tracking. By moving the mouse and clicking, you can drag the cube around or resize it by grabbing the bounds. You can find more information (links etc.) in the repository’s ReadMe.`}</p>
    <img {...{
      "src": "https://i.ibb.co/Hn66c79/Screenshot-2022-09-14-151807.png",
      "alt": null
    }}></img>
    <p>{`For a far more involved Unity project, which we definitely suggest you to check out, visit the `}<a parentName="p" {...{
        "href": "https://github.com/microsoft/ZappysPlayground"
      }}>{`ZappysPlayground`}</a>{` repository, clone it, and open the Unity project. It shows many features of MRTK 3, together with Azure Spatial Anchors and many, many more features. While that project is great for inspiration, we don’t suggest using it as a starting point, because it is very large/bloated already.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://youtu.be/qfONlUCSWdg"
        }}>{`MRTK (Mixed Reality Toolkit) 2.6.0 Release`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://youtube.com/playlist?list=PLlrxD0HtieHhkPlibqfQf1pGvM0vLNPpL"
        }}>{`Mixed Reality Dev Days 2022 - YouTube Playlist`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=cMrIvPrkB0Y&list=PLlrxD0HtieHhkPlibqfQf1pGvM0vLNPpL&index=22"
        }}>{`Mixed Reality and the Web with Babylon.js 5.0`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/windows/mixed-reality/discover/designing-holograms?ocid=AID3054426"
        }}>{`The making of Designing Holograms`}</a></li>
    </ul>
    <h2>{`Microsoft Mesh (Preview)`}</h2>
    <p>{`Mesh enables people to connect with a holographic presence, share across space,
and collaborate from anywhere in the world.`}</p>
    <img {...{
      "src": "https://docs.microsoft.com/en-us/mesh/media/holographic-collab.png?ocid=AID3054426",
      "alt": null
    }}></img>
    <ul>
      <li parentName="ul">{`Mesh Overview: `}<a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/mesh/overview?ocid=AID3054426"
        }}>{`https://docs.microsoft.com/en-us/mesh/overview`}</a></li>
      <li parentName="ul">{`Get Started with Mesh App on your Hololens 2 (Preview): `}<a parentName="li" {...{
          "href": "https://docs.microsoft.com/en-us/mesh/mesh-app/?ocid=AID3054426"
        }}>{`https://docs.microsoft.com/en-us/mesh/mesh-app`}</a></li>
    </ul>
    <h2>{`Other Topics`}</h2>
    <h3>{`Microsoft for Startups`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://aka.ms/Startups/FoundersHub"
        }}>{`Microsoft Founders Hub`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=NBeZT2acsuk"
        }}>{`Founders Hub - Presentation`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      